import getNormalizedError from './getNormalizedError'
import makeContent from './makeContent'

/**
 * Unhandled Promise Rejection esetén ezt a tartalmat generálja.
 * @param event - A hibaesemény.
 */
export default function makeUnhandledPromiseErrorContent (event: PromiseRejectionEvent): HTMLElement {
  const error = getNormalizedError(event.reason)

  const message = `
    ${ error.message }
    <h3>
      <ul>
        <li>Lehetett async/await, ekkor try-catch kell</li>
        <li>Lehetett hagyományos Promise, akkor ott a catch ágat kell kifejtened</li>
      </ul>
    </h3>
  `

  return makeContent(message, error.stack)
}
